import Api from '../api'

export default {
    '_countries': [],
    getCountries(fuel, filters, callback) {
        if (this._countries[fuel + '-' + Object.keys(filters).map(key => `${key}|${filters[key]}`).join("-")]) {
            callback(this._countries[fuel + '-' + Object.keys(filters).map(key => `${key}|${filters[key]}`).join("-")]);
        } else {
            const $scope = this;

            Api.getCountries(fuel, filters, function (err, res) {
                $scope._countries[fuel + '-' + Object.keys(filters).map(key => `${key}|${filters[key]}`).join("-")] = res;
                callback(res);
            });
        }
    },
    get(country, fuel, callback) {
        var _sel_country = null;
        if (parseInt(country) == country) return this.getById(country, fuel, filters, callback);

        this.getCountries(fuel, filters, function (Countries) {
            Countries.forEach(function (_country, index) {
                if (_country.value.toLowerCase() == country.toLowerCase()) _sel_country = _country;
            });
            callback(_sel_country);
        });
    },
    getById(country_id, fuel, filters, callback) {
        var _sel_country = null;
        this.getCountries(fuel, filters, function (Countries) {
            Countries.forEach(function (_country, index) {
                if (_country.idstato == country_id) _sel_country = _country;
            });
            callback(_sel_country);
        });
    },
    getByISOCode(country_iso, fuel, filters, callback) {
        var _sel_country = null;
        this.getCountries(fuel, filters, function (Countries) {
            Countries.forEach(function (_country, index) {
                if (_country.sprite == country_iso) _sel_country = _country;
            });
            callback(_sel_country);
        });
    },
    getMarkers(fuel, filters, callback) {
        this.getCountries(fuel, filters, function (Countries) {
            var _markers = [];

            Countries.forEach(function (_country, index) {
                _markers.push({
                    type: 'country',
                    position: {
                        lat: Number.parseFloat(_country.position.lat),
                        lng: Number.parseFloat(_country.position.lng)
                    },
                    value: _country.value,
                    stations: _country.stations,
                    style: {
                        'background-image': "url('" + require('../assets/countries/' + _country.sprite + '.svg') + "')"
                    },
                    price: _country.avgprice,
                    sprite: _country.sprite,
                    zoom: _country.zoom,
                    next_hop: 'country'
                })
            });

            callback(_markers);
        })
    },
    getMaxZoom(fuel) {
        var _maxZoom = 6; // override per stati grandi tipo Russia

        /*
                this.getCountries(fuel,function(Countries) {
                    Countries.forEach(function (_country) {
                        if (_country.zoom < _maxZoom) _maxZoom = _country.zoom;
                    });
                });
        */

        return _maxZoom;
    }
}